<template>
    <v-card
        class="mx-auto"
        elevation="1"
        :loading="loading"
        tile
    >
        <v-img
            class="white--text align-end"
            height="200px"
            src="/img/bricks/invoicing_brick_2.jpg"
        >
            <v-list-item>
                <v-list-item-avatar :color="circle_color" class="headline white--text">{{ data.count }}
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title class="headline white--text">Send invoice</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-img>

        <v-card-subtitle class="pb-0">Let's check it out in numbers:</v-card-subtitle>

        <v-simple-table>
            <tbody>
            <tr>
                <td>Not send total:</td>
                <td class="text-right">{{ data.total | toCurrency(curr) }}</td>
            </tr>
            <tr>
                <td>Unfinished:</td>
                <td class="text-right">{{ data.unfinished }}</td>
            </tr>
            <tr>
                <td>Unfinished total:</td>
                <td class="text-right">{{ data.unfinished_total | toCurrency(curr) }}</td>
            </tr>
            </tbody>
        </v-simple-table>

        <v-divider></v-divider>

        <v-card-actions>
            <v-btn
                color="warning"
                depressed
                @click="dialogUnsent = true"
                :disabled="!data.unfinished"
            >
                Unfinished
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                color="success"
                depressed
                @click="dialog = true"
                :disabled="!data.count"
            >
                Resolve
            </v-btn>
            <v-dialog v-model="dialog" persistent v-if="data.count">
                <v-card :loading="invoiceListLoading">
                    <v-card-title
                        class="headline grey lighten-2"
                        primary-title
                    >
                        Set release date ({{ selected.length }})
                    </v-card-title>
                    <v-card-text class="pa-0 ma-0">
                        <list
                            :list="data.list"
                            :curr="curr"
                            :selectable="true"
                        ></list>
                    </v-card-text>
                    <v-card-actions class="pa-5">
                        <v-btn :disabled="!selected.length" depressed color="success" @click="dialogUpdate = true">Send default invoice letter
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn depressed color="error" @click="dialog = false">
                            <v-icon small left>fa-times</v-icon>
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog
                v-model="dialogUpdate"
                max-width="500px"
            >
                <v-card :loading="dialogUpdateLoading">
                    <v-card-title class="headline" primary-title>
                        Are you sure?
                    </v-card-title>
                    <v-card-text>
                        You are going to send default email with PDF invoice to {{ selected.length }} client<span v-if="selected.length > 1">s</span>. It will <strong>change invoices status</strong> and set date of sending to <strong>{{ new Date() | formatDate }}</strong>. If you are sure, just confirm it here:
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="success"
                            dark
                            @click="updateReleaseDate"
                        >Yes, send invoice to {{ selected.length }} client<span v-if="selected.length > 1">s</span>!</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogUnsent" persistent v-if="data.count">
                <v-card :loading="invoiceListLoading">
                    <v-card-title
                        class="headline grey lighten-2"
                        primary-title
                    >
                        List of unfinished biographies
                    </v-card-title>
                    <v-card-text class="pa-0 ma-0">
                        <list
                            :list="data.tosolve"
                            :curr="curr"
                            :selectable="false"
                        ></list>
                    </v-card-text>
                    <v-card-actions class="pa-5">
                        <v-spacer></v-spacer>
                        <v-btn depressed color="error" @click="dialogUnsent = false">
                            <v-icon small left>fa-times</v-icon>
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card-actions>

    </v-card>
</template>

<script>

    import list from './list'
    import { mapGetters } from 'vuex'
    import api from '../_api'
    import moment from "moment";

    export default {
        name: "brick_1",

        props: {
            loading: true,
            data: {},
            curr: null
        },

        components: {
            list
        },

        data() {
            return ({
                dialog: false,
                dialogUpdate: false,
                dialogUpdateLoading: false,
                dialogUnsent: false,
                invoiceListLoading: false
            })
        },

        computed: {
            ...mapGetters({
                selected: 'invoices/selected'
            }),

            circle_color() {
                return (this.data.count) ? 'red' : 'green'
            }
        },

        methods: {
            newReleaseDate() {
                return moment(new Date()).add(14, 'days')
            },

            newDueDate: function() {
                return moment(new Date()).add(28, 'days')
            },

            updateReleaseDate() {
                this.dialogUpdateLoading = true;
                this.invoiceListLoading = true;
                api.updateInvoice(this.selected, {
                    'release_date' : this.newReleaseDate(),
                    'due_date' : this.newDueDate()
                }).then(response => {
                    this.dialogUpdate = false;
                    this.dialogUpdateLoading = false;
                    this.data.list = [];
                    this.invoiceListLoading = false;
                    this.dialog = false;
                    this.reload();
                })
            },

            reload() {
                this.$emit('reload')
            }
        }
    }
</script>

<style scoped>

</style>
